import React from 'react'
import PropTypes from 'prop-types'
import { Heading, Box, Container } from '@chakra-ui/react'

const TitleLayoutOne = ({ data, theme, dataTestId }) => {
  return (
    <Box bg={theme.backgroundColor} px={[2, 4, 8, 16]}>
      <Box bg={theme.backgroundColor} py={8} px={[4, 4, 0, 0]}>
        <Container maxW='container.lg' mx='auto' textAlign='left' px={0}>
          <Heading
            as='h2'
            color={theme.sectionTitleColor}
            fontFamily='heading'
            fontSize='sectionTitle'
            fontWeight='heading'
          >
            {data.title}
          </Heading>
        </Container>
      </Box>
    </Box>
  )
}

TitleLayoutOne.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default TitleLayoutOne
